<div>

  <button pButton icon="fa fa-plus-square-o" label="Add Users/Groups" class="add-button" (click)="createShare()"></button>

  <div style="height: 44px;"></div>

  @if (hasEntries) {
    <div>
      <!-- Data table -->
      <p-table #dt [value]="entries" [scrollable]="true" scrollHeight="500px" [customSort]="true"
        [resizableColumns]="true" (sortFunction)="doCustomSort($event)">
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn pSortableColumn="shareTargetName">
              Shared With
              <p-sortIcon field="shareTargetName"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="shareTargetType">
              Type
              <p-sortIcon field="shareTargetType"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="accessType">
              Access
              <p-sortIcon field="accessType"></p-sortIcon>
            </th>
            <th pResizableColumn pSortableColumn="modified">
              Modified
              <p-sortIcon field="modified"></p-sortIcon>
            </th>
            <th class="uv-table-button-column-1">
            </th>
          </tr>
          <tr>
            <th>
              <input pInputText type="text" (input)="dt.filter($event.target.value, 'shareTargetName', 'contains')"
                style="width: 100%;">
              </th>
              <th>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'shareTargetType', 'contains')"
                  style="width: 100%;">
                </th>
                <th>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'accessType', 'contains')"
                    style="width: 100%;">
                  </th>
                  <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'modified', 'contains')"
                      style="width: 100%;">
                    </th>
                    <th class="uv-table-button-column-1">
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                  <tr>
                    <td>
                      <span class="uv-table-value">{{rowData.shareTargetName}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData.shareTargetType}}</span>
                    </td>
                    <td>
                      <select style="padding: 3.75px;" (change)="accessChanged(rowData.tag, $event.target.value)">
                        <option value="view" [attr.selected]="(rowData.accessType == 'view') ? '' : null">View</option>
                        <option value="edit" [attr.selected]="(rowData.accessType == 'edit') ? '' : null">Edit</option>
                      </select>
                      <button pButton style="margin: 0px 0px 0px 10px !important;" label="Advanced..." (click)="editPrivileges(rowData.tag)">
                      </button>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData.modified}}</span>
                    </td>
                    <td class="uv-table-button-column-1">
                      <button type="button" class="btn btn-danger" title="Unshare this network"
                        (click)="deleteShare(rowData.tag)">
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          }

          @if (!hasEntries) {
            <div style="font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: large; margin-top: 20px; margin-bottom: 20px;">
              This network has not been shared with anyone
            </div>
          }

          <share-editor [(display)]="displayShareEditor" [sharedItemGuid]="sharedItemGuid"
          [sourceUserGuid]="sourceUserGuid" (onOK)="onShareCreated()"></share-editor>

          <share-privileges-editor [target]="targetShare?.Privileges" [(display)]="displayPrivilegesEditor" (onOK)="onPrivilegesEditorOK()"
            (onCancel)="onPrivilegesEditorCancel()">
          </share-privileges-editor>

        </div>
